import { v4 as uuidv4 } from 'uuid';

import WorkspaceItemCommentSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceItemComment.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';
import { showNotificationError } from 'Shared/helpers';

import QueryParamConstants from '../constants/QueryParams.constants';
import WorkspaceItemCommentsConstants from '../constants/WorkspaceItemComments.constants';

import * as WorkspaceItemCommentsAPI from '../api/WorkspaceItemComments.api';

export const fetchWorkspaceItemCommentsSuccess = payload => ({
  type: WorkspaceItemCommentsConstants.Actions.FETCH_WORKSPACE_ITEM_COMMENTS_SUCCESS,
  payload,
});

export const createWorkspaceItemCommentSuccess = payload => ({
  type: WorkspaceItemCommentsConstants.Actions.CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS,
  payload,
});

export const updateWorkspaceItemCommentSuccess = payload => ({
  type: WorkspaceItemCommentsConstants.Actions.UPDATE_WORKSPACE_ITEM_COMMENT_SUCCESS,
  payload,
});

export const deleteWorkspaceItemCommentSuccess = workspaceItemCommentUuid => ({
  type: WorkspaceItemCommentsConstants.Actions.DELETE_WORKSPACE_ITEM_COMMENT_SUCCESS,
  payload: workspaceItemCommentUuid,
});

export const fetchWorkspaceItemComments = meetingItemId => dispatch => {
  const params = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    [QueryParamConstants.Api.WORKSPACE_ITEM_ID]: meetingItemId,
  };

  return WorkspaceItemCommentsAPI.fetchWorkspaceItemComments(params)
    .then(response => {
      dispatch(fetchWorkspaceItemCommentsSuccess(normalizer(WorkspaceItemCommentSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const createWorkspaceItemComment = (meetingItemId, content) => dispatch => {
  const uuid = uuidv4();

  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    [QueryParamConstants.Api.WORKSPACE_ITEM_ID]: meetingItemId,
    uuid,
    ...content,
  };

  const toSend = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'object') {
      for (const [key2, value2] of Object.entries(value)) {
        toSend.append(`${key}[${key2}]`, value2);
      }
    } else {
      toSend.append(key, value);
    }
  }

  return WorkspaceItemCommentsAPI.createWorkspaceItemComment(toSend)
    .then(response => {
      dispatch(createWorkspaceItemCommentSuccess(normalizer(WorkspaceItemCommentSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateWorkspaceItemComment = data => dispatch => {
  const dataToSend = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    ...data,
  };

  return WorkspaceItemCommentsAPI.updateWorkspaceItemComment(dataToSend)
    .then(response => {
      dispatch(updateWorkspaceItemCommentSuccess(normalizer(WorkspaceItemCommentSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const deleteWorkspaceItemComment = workspaceItemCommentUuid => dispatch => {
  return WorkspaceItemCommentsAPI.deleteWorkspaceItemComment(workspaceItemCommentUuid)
    .then(response => {
      dispatch(deleteWorkspaceItemCommentSuccess(workspaceItemCommentUuid));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
